export default "__VITE_ASSET__BUq5sK$h__"